var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeaderOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000006281"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7856_70605)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    rx: 4,
    fill: "url(#paint0_linear_7856_70605)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11986",
    x: 0.49804,
    width: 13.6114,
    height: 13.6114,
    rx: 1.65,
    transform: "matrix(0.711485 -0.702701 0.711485 0.702701 -1.20787 16.4066)",
    fill: "url(#paint1_linear_7856_70605)",
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11985",
    x: 0.49804,
    width: 13.6114,
    height: 13.6114,
    rx: 1.65,
    transform: "matrix(0.711485 -0.702701 0.711485 0.702701 -1.20787 0.406614)",
    fill: "url(#paint2_linear_7856_70605)",
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 11987",
    filter: "url(#filter0_f_7856_70605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1,
    width: 5,
    height: 2,
    rx: 1,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 17.3,
    height: 15.3,
    rx: 3.65,
    stroke: "black",
    strokeWidth: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7856_70605",
    x: 1.9,
    y: -1.1,
    width: 9.2,
    height: 6.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.05,
    result: "effect1_foregroundBlur_7856_70605"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7856_70605",
    x1: 18,
    y1: 8,
    x2: 0,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFEF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DC50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7856_70605",
    x1: 7.15569,
    y1: 0,
    x2: 7.15569,
    y2: 14.3114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.600209,
    stopColor: "#ED7B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7856_70605",
    x1: 7.15569,
    y1: 0,
    x2: 7.15569,
    y2: 14.3114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.274786,
    stopColor: "#FFF8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED65"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7856_70605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeaderOrder);
export default __webpack_public_path__ + "static/media/icon-header-order.053d1a0f4e0f0f7819778af281d8c9a3.svg";
export { ForwardRef as ReactComponent };